<template>
  <div id="beHavior">
    <a-row class="pageProperty-btn" type="flex" justify="start">
      <a-col>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('generic.Add') }}</span>
          </template>
          <img @click="addBehavior('add')" style="margin-left: 10px;" class="sbxs" src="../../../assets/img/ss-add.png"  width="22" height="22">
        </a-tooltip>
        <a-popconfirm
                :title="$t('generic.AreyoudeleTask')"
                @confirm="deleteBehavior"
                :okText="$t('generic.Yes')"
                :cancelText="$t('generic.No')"
        >
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.Delete') }}</span>
            </template>
            <img class="sbxs" style="margin:0 10px;" src="../../../assets/img/ss-delete.png"  width="22" height="22">
          </a-tooltip>
        </a-popconfirm>
      </a-col>

      <a-col class="ml4">
        <a-row type="flex" justify="start">
          <a-col><span>{{ $t('generic.ButtonGroupName') }}</span></a-col>
          <a-col style="margin: 0 4px;">
            <a-tooltip
                    :trigger="['focus']"
                    placement="topLeft"
                    overlayClassName="numeric-input"
            >
              <span slot="title" v-if="groupName.length > 0">
                {{ groupName }}
              </span>
              <template slot="title" v-else>
                {{ $t('generic.ButtonGroupName') }}
              </template>
              <a-input size="small" v-model="groupName"/>
            </a-tooltip>
          </a-col>
          <a-col>
            <a-button size="small" type="primary" @click="applyButGropName"> {{ $t('generic.Apply') }}</a-button>
          </a-col
          >
        </a-row>
      </a-col>
    </a-row>
    <a-table
            :rowSelection="{
        selectedRowKeys: beHaviorRowKeys,
        onChange: onSelectChange
      }"
            :dataSource="beHaviorTable"
            :columns="columns"
            :pagination="Nopagination"
            :loading="loading"
            size="small"
            :locale="tabelText"
    >
      <template
              v-for="(item, index) in scopedSlotsArray"
              :slot="item"
              slot-scope="text"
      >
        <span :key="index">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span class="tableFontSize">{{
                  text === "1" || text === true
                      ? "Yes"
                      : text === "0" || text === false
                      ? "No"
                      : text === ""
                          ? "-"
                          : text
                }}</span>
            </template>
            <div class="tableFontSize" v-if="item != 'pattern'">
              {{
                text === "1" || text === true
                    ? "Yes"
                    : text === "0" || text === false
                    ? "No"
                    : text === null
                        ? "-"
                        : text
              }}
            </div>
            <a-icon type="tags" v-else />
          </a-tooltip>
        </span>
      </template>
      <a-button
              slot="operation"
              size="small"
              type="primary"
              shape="circle"
              icon="edit"
              slot-scope="text"
              style="background: #9c9446;border:none"
              @click="addBehavior('edit', text)"
      ></a-button>
    </a-table>
    <!--编辑-->
    <a-modal
            title="Add Behavior"
            centered
            v-model="behaviorVis"
            width="60%"
            :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" v-if="isjlDetele" @click="jlDeleteClick">{{ $t('generic.Configuration') }}</a-button
        >
        <a-button type="primary" @click="getBehavior" :disabled="getBehaviorDis">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="$t('generic.Name')" v-bind="formItemLayout">
              <a-input
                      :placeholder="$t('generic.Name')"
                      style="width: 100%;"
                      autocomplete="off"
                      v-decorator="[
                  'name',
                  {
                    initialValue: editFromItems.name
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.RenderType')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      :placeholder="$t('generic.RenderType')"
                      v-decorator="[
                  'renderType',
                  {
                    initialValue: editFromItems.renderType
                  }
                ]"
              >
                <a-select-option
                        v-for="(item, index) in selectBehaviorArr.renderTypes"
                        :value="item.dataKey"
                        :key="index"
                >{{ item.dataValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Type')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      :placeholder="$t('generic.Type')"
                      v-decorator="[
                  'type',
                  {
                    initialValue: editFromItems.type
                  }
                ]"
              >
                <a-select-option value="BUTTON">Button</a-select-option>
                <a-select-option value="POPUP">Popup</a-select-option>
                <a-select-option value="File">File</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Code')" v-bind="formItemLayout">
              <a-select
                      style="width: 100%"
                      :placeholder="$t('generic.Code')"
                      @change="codeChange"
                      v-decorator="[
                  'code',
                  {
                    initialValue: editFromItems.codeKey,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              >
                <a-select-option
                        v-for="(item, index) in selectBehaviorArr.code"
                        :value="item.dataKey"
                        :key="index"
                >{{ item.dataValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ViewType')" v-bind="formItemLayout">
              <a-select
                      allowClear
                      :placeholder="$t('generic.ViewType')"
                      v-decorator="[
                  'viewType',
                  {
                    initialValue: editFromItems.viewType
                  }
                ]"
              >
                <a-select-option value="LIST">List</a-select-option>
                <a-select-option value="SINGLE">Single</a-select-option>
                <a-select-option value="EXCEL">Excel</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <hr />
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.PatternType')" v-bind="formItemLayout">
              <a-radio-group v-model="patternTypeApi">
                <a-radio value="INT">
                  Internal
                </a-radio>
                <a-radio value="EXT">
                  Extenal
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="patternTypeApi == 'EXT'">
            <a-form-item :label="$t('generic.ExtenalAPI')" v-bind="formItemLayout">
              <a-input
                      :placeholder="$t('generic.ExtenalAPI')"
                      autocomplete="off"
                      style="width: 100%;"
                      v-decorator="[
                  'externalApi',
                  {
                    initialValue: editFromItems.externalApi,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <hr />
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
              <a-cascader
                      allowClear
                      :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                      :options="behaviorModules"
                      expandTrigger="hover"
                      :placeholder="$t('generic.Module')"
                      v-model="behaviorModuleModel"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.MapToModule')" v-bind="formItemLayout">
              <a-cascader
                      allowClear
                      :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                      :options="behaviorMaoToModules"
                      expandTrigger="hover"
                      :placeholder="$t('generic.MapToModule')"
                      v-model="behaviorMaoToModel"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.FieldMap')" v-bind="formItemLayout">
              <a-select
                      allowClear
                      :placeholder="$t('generic.FieldMap')"
                      @dropdownVisibleChange="($event) =>{$event ? dropdownVisibleChange() : null }"
                      v-decorator="[
                  'mapHeaderUid',
                  {
                    initialValue: editFromItems.mapHeaderUid
                  }
                ]"
              >
                <a-select-option
                        v-for="(item, index) in FormFieldMapList"
                        :key="index"
                        :value="item.fieldMapUid"
                >{{ item.mapName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <hr />
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item :label="$t('generic.BehaviorPattern')" :labelCol="{ span: 4 }">
              <a-textarea
                      :placeholder="$t('generic.BehaviorPattern')"
                      :rows="3"
                      style="width: 70%"
                      disabled
                      :value="JSON.stringify(getConfigJson)"
              />
              <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="plus"
                      style="margin:0 4px 0 14px;"
                      @click="configPatternData"
              ></a-button>
              <a-button
                      size="small"
                      type="primary"
                      shape="circle"
                      icon="delete"
                      style="background: #f5222d;border:none"
                      @click="clearConfigJson"
              ></a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      :title="$t('generic.BehaviorPattern')"
      v-model="configPatterVis"
      width="60%"
      :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" @click="getBehaviorPatterConfig">{{$t('publicLang.Save')}}</a-button>
      </template>
      <a-form :form="behaviorPatternForm">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
              <a-cascader
                      :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                      :options="gmcuidModule"
                      expandTrigger="hover"
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-model="ConfigGmcModule"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Function')" v-bind="formItemLayout">
              <a-select
                  style="width: 100%"
                  allowClear
                  :placeholder="$t('publicLang.PleaseSelect')"
                  v-model="ConfigGmcFunction"
              >
                <a-select-option
                    v-for="(item, index) in gmcuidfunction"
                    :value="item.functionKey"
                    :key="index"
                >{{ item.functionValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.GenericName')" v-bind="formItemLayout">
              <a-select
                allowClear
                style="width: 100%"
                :placeholder="$t('publicLang.PleaseSelect')"
                @dropdownVisibleChange="($event) =>{$event ? genericNameVisibleChange() : null }"
                v-decorator="['gmcUid', { initialValue: getConfigJson.gmcUid }]"
              >
                <a-select-option
                        v-for="(item, index) in gmcuidGeneric"
                        :value="item.uid"
                        :key="index"
                >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Parameters')" v-bind="formItemLayout">
              <a-select
                      allowClear
                      v-decorator="[
                  'params',
                  {
                    initialValue:
                      getConfigJson.params == null ? [] : getConfigJson.params,
                    rules: [{ type: 'array' }]
                  }
                ]"
                      mode="multiple"
                      :placeholder="$t('publicLang.PleaseSelect')"
              >
                <a-select-option
                        v-for="(item, index) in ParametersList"
                        :value="item.detailUid"
                        :key="index"
                >{{ item.FieldName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <hr />
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.CustPage')" v-bind="formItemLayout">
              <a-input
                  :placeholder="$t('generic.CustPage')"
                  v-decorator="[
                  'custPage',
                  { initialValue: getConfigJson.custPage }
                ]"/>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.Action')" v-bind="formItemLayout">
              <a-input
                :placeholder="$t('generic.Action')"
                v-decorator="[
                  'action',
                  { initialValue: getConfigJson.action }
                ]"/>
            </a-form-item>
          </a-col>


          <a-col :span="12" v-if="isWidth">
            <a-form-item :label="$t('generic.Width')" v-bind="formItemLayout">
              <a-input-number
                      :min="0"
                      :max="100"
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace('%', '')"
                      v-decorator="['width', { initialValue: getConfigJson.width }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24"></a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ConsParameter')" v-bind="formItemLayout">
              <a-select
                  allowClear
                  mode="multiple"
                  :placeholder="$t('publicLang.PleaseSelect')"
                  v-decorator="[
                  'constraintParams',
                  {
                    initialValue:
                      getConfigJson.constraintParams == null
                        ? []
                        : getConfigJson.constraintParams,
                    rules: [{ type: 'array' }]
                  }
                ]">
                <a-select-option
                        v-for="(item, index) in ParametersList"
                        :value="item.detailUid"
                        :key="index"
                >{{ item.FieldName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Constrainttable')" v-bind="formItemLayout">
              <a-select
                    style="width: 100%"
                    allowClear
                    mode="multiple"
                    :placeholder="$t('publicLang.PleaseSelect')"
                    v-decorator="[
                      'constraintTableName',
                      {
                        initialValue:
                          getConfigJson.constraintTableName == null
                            ? []
                            : getConfigJson.constraintTableName,
                        rules: [{ type: 'array' }]
                      }
                    ]">
                  <a-select-option
                          v-for="(item, index) in paterTableName"
                          :value="item.tableName"
                          :key="index">
                    {{ item.tableName }}
                  </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
            :title="$t('generic.Configuration')"
            v-model="deleteBehaviorSqlVis"
            width="75%"
            :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" @click="() => (deleteBehaviorSqlVis = !deleteBehaviorSqlVis)">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <div>
        <a-button
                size="small"
                type="primary"
                shape="circle"
                icon="plus"
                @click="addDeleteSQL"
        ></a-button>
        <hr />
        <vxe-table
                ref="xTableDelete"
                border
                resizable
                show-overflow
                size="mini"
                :data.sync="configuraTionData"
                :edit-config="{ trigger: 'manual', mode: 'row', key: 'id' }"
        >
          <vxe-table-column
            field="seq"
            :title="$t('generic.Seq')"
            width="80"
            :edit-render="{ name: 'input' }">
            <template v-slot:edit="{ row }">
              <a-input-number size="small" v-model="row.seq" style="width: 100%;"/>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="validSql"
            :title="$t('generic.ValidationSQL')"
            min-width="500"
            :edit-render="{ name: 'input' }">
            <template v-slot:edit="{ row }">
              <a-textarea
                  v-model="row.validSql"
                  size="small"
                  style="width: 100%;"
                  :rows="2"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="validParam"
              :title="$t('generic.Parameters')"
              min-width="200"
              :edit-render="{ name: 'Select' }"
          >
            <template v-slot:edit="{ row }">
              <a-select
                  mode="multiple"
                  style="width: 100%"
                  v-model="row.validParam"
              >
                <a-select-option
                        v-for="(item, index) in ParametersList"
                        :value="item.detailUid"
                        :key="item.detailUid"
                >{{ item.FieldName }}</a-select-option
                >
              </a-select>
            </template>
          </vxe-table-column>
          <vxe-table-column :title="$t('generic.operate')">
            <template v-slot="{ row }">
              <template v-if="$refs.xTableDelete.hasActiveRow(row)">
                <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="check"
                    @click="saveDeleteRowEvent(row)"
                    style="margin: 0 4px"
                ></a-button>
                <a-button
                    size="small"
                    type="danger"
                    shape="circle"
                    icon="close"
                    @click="cancelDeleteRowEvent(row)"
                ></a-button>
              </template>
              <template v-else>
                <a-button
                        size="small"
                        type="primary"
                        shape="circle"
                        icon="edit"
                        @click="editDeleteRowEvent(row)"
                        style="background: #9c9446;border:none;margin: 0 4px"
                ></a-button>
                <a-popconfirm
                        :title="$t('generic.AreyoudeleTask')"
                        @confirm="deleteSQLBehavior(row)"
                        :okText="$t('generic.Yes')"
                        ;cancelText="$t('generic.No')"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>{{ $t('generic.Delete') }}</span>
                    </template>
                    <a-button
                        size="small"
                        type="primary"
                        shape="circle"
                        icon="delete"
                        style="background: #f5222d;border:none"
                    ></a-button>
                  </a-tooltip>
                </a-popconfirm>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </a-modal>
  </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import { mapState } from "vuex";
    export default {
        data() {
            return {
                getBehaviorDis: false, // 按钮提交disabled
                paterTableName: [], // patter TableName
                groupName: "", // group BUtton Name
                tabelText: { emptyText: "No record found" }, // table 空数据提示
                maskClosable: false, // 取消弹窗遮罩
                scopedSlotsArray: [
                    "type",
                    "code",
                    "name",
                    "renderType",
                    "pattern",
                    "group"
                ], // table slot
                Nopagination: false, // 分页
                behaviorVis: false, // modal 流阀
                formItemLayout: {
                    // label宽度设置
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                loading: false, // table loading
                beHaviorTable: [], // behavior table数据
                beHaviorRowKeys: [], // checked选中的index
                selectBeHaviorRows: [], // checked选中的值

                behaviorMaoToModules: [], // Map To Module 下拉数据
                behaviorMaoToModel: [], // Map To Module 选中的值
                behaviorModules: [], //  Module 下拉数据
                behaviorModuleModel: [], //Module 选中的值
                selectBehaviorArr: {}, // 编辑新增加下拉值集合
                patternTypeApi: "INT", // pattern type 类型
                FormFieldMapList: [], // fieldMap 下拉数据
                editFromItems: {}, // 编辑当条数据
                //        配置JSON
                configPatterVis: false, // patterJSON 配置弹窗控制
                ParametersList: [], // Parameter下拉数据
                gmcuidModule: [], // 配置gmc-uid module下拉数据
                gmcuidfunction: [], // 配置gmc-uid function 下拉数据
                gmcuidGeneric: [], // 配置gmc-uid genericName下拉数据
                isWidth: false, // 是否填写width
                ConfigGmcModule: [], // 配置gmc-uid module 选中数据
                ConfigGmcFunction: undefined, // 配置gmc-uid Function 选中数据
                getConfigJson: {}, // 配置json
                isjlDetele: false,
                deleteBehaviorSqlVis: false,
                configuraTionData: [],
                form:this.$form.createForm(this),
                behaviorPatternForm:this.$form.createForm(this),
            };
        },
        computed: {
            columns(){
              return   [
                  {
                      title: this.$t("generic.Type"),
                      dataIndex: "type",
                      scopedSlots: { customRender: "type" }
                  },
                  {
                      title: this.$t("generic.Code"),
                      dataIndex: "code",
                      scopedSlots: { customRender: "code" }
                  },
                  {
                      title: this.$t("generic.Name"),
                      dataIndex: "name",
                      scopedSlots: { customRender: "name" }
                  },
                  {
                      title:  this.$t("generic.RenderType"),
                      dataIndex: "renderType",
                      scopedSlots: { customRender: "renderType" }
                  },
                  {
                      title: this.$t("generic.BehaviorPattern"),
                      dataIndex: "pattern",
                      scopedSlots: { customRender: "pattern" }
                  },
                  {
                      title: this.$t("generic.Group"),
                      dataIndex: "group",
                      scopedSlots: { customRender: "group" }
                  },
                  {
                      title: this.$t("generic.Group"),
                      scopedSlots: { customRender: "operation" }
                  }
              ]
            },
            ...mapState(["uid"]) // 获取uid
        },
        watch: {
            //      监听uid是否有值 请求对应tabs数据
            uid(val) {
                if (val != "") {
                    this.initBehaviorTbale();
                }
            }
        },
        created() {
            ajax.get(api.DROPTABNAME).then(res => {
                this.paterTableName = res.data;
            });
            this.initBehaviorTbale();
        },
        methods: {
            //      保存当条删除配置SQL
            saveDeleteRowEvent(row) {
                let params = {
                    gmcUid: this.uid,
                    seq: row.seq,
                    uid: row.uid == undefined ? "" : row.uid,
                    validParam: JSON.stringify(row.validParam),
                    validSql: row.validSql
                };

                ajax.post(api.VALIDSQL, params).then(res => {
                    if (res.code == 200) {
                        ajax.get(api.VALIDSQL, { gmcUid: this.uid }).then(res => {
                            this.configuraTionData = res.data;
                            for (let i in this.configuraTionData) {
                                this.configuraTionData[i].id = i;
                                this.configuraTionData[i].validParam = JSON.parse(
                                    this.configuraTionData[i].validParam
                                );
                            }
                        });
                    }
                });
            },
            //      编辑删除SQL配置
            editDeleteRowEvent(row) {
                this.$refs.xTableDelete.setActiveRow(row);
            },
            deleteSQLBehavior(row) {
                let params = {
                    uid: row.uid
                };
                ajax.post(api.DELETEVALISQL, params).then(res => {
                    if (res.code == 200) {
                        ajax.get(api.VALIDSQL, { gmcUid: this.uid }).then(res => {
                            this.configuraTionData = res.data;
                            for (let i in this.configuraTionData) {
                                this.configuraTionData[i].id = i;
                                this.configuraTionData[i].validParam = JSON.parse(
                                    this.configuraTionData[i].validParam
                                );
                            }
                        });
                    }
                });
            },
            //      取消删除配置SQL
            cancelDeleteRowEvent(row) {
                this.$refs.xTableDelete.clearActived();
                this.$refs.xTableDelete.revert(row);
            },
            //      添加删除配置SQL
            addDeleteSQL() {
                let record = {
                    seq: "",
                    validSql: "",
                    validParam: []
                };
                this.$refs.xTableDelete
                    .insert(record)
                    .then(({ row }) => this.$refs.xTableDelete.setActiveRow(row));
            },
            //      获取ParametersList data 下拉数据
            jlDeleteClick() {
                this.configuraTionData = [];
                this.deleteBehaviorSqlVis = true;

                let schemaParas = {
                    schemaUids: [],
                    uid: this.uid
                };
                ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {
                    this.ParametersList = res.data;
                });
                ajax.get(api.VALIDSQL, { gmcUid: this.uid }).then(res => {
                    this.configuraTionData = res.data;
                    for (let i in this.configuraTionData) {
                        this.configuraTionData[i].id = i;
                        this.configuraTionData[i].validParam = JSON.parse(
                            this.configuraTionData[i].validParam
                        );
                    }
                });
            },
            codeChange(val) {
                if (val == "BTN_DELETE") {
                    this.isjlDetele = true;
                } else {
                    this.isjlDetele = false;
                }
            },
            //      button分类提交
            applyButGropName() {
                if (this.selectBeHaviorRows.length > 0) {
                    let paramsArray = [];
                    for (let ii in this.selectBeHaviorRows) {
                        paramsArray.push(this.selectBeHaviorRows[ii].behrUid);
                    }
                    let params = {
                        group: this.groupName,
                        uids: paramsArray
                    };
                    ajax.post(api.BUTGROUP, params).then(res => {
                        if (res.code == 200) {
                            this.initBehaviorTbale();
                        }
                    });
                } else {
                    this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
                }
            },
            //      table 初始化list
            initBehaviorTbale() {
                if (this.uid === "") {
                    this.loading = false;
                    return;
                }
                this.loading = true;
                let params = {
                    uid: this.uid
                };
                ajax.get(api.GETBEGAVIORDETAIL, params).then(res => {
                    this.loading = false;
                    if (res.code === 200) {
                        this.beHaviorTable = res.data;
                    }
                });
            },
            //      删除Beahavior Table
            deleteBehavior() {
                if (this.selectBeHaviorRows.length > 0) {
                    this.loading = true;
                    let paramsArray = [];
                    for (let ii in this.selectBeHaviorRows) {
                        paramsArray.push(this.selectBeHaviorRows[ii].behrUid);
                    }
                    let params = {
                        behaviorUid: paramsArray
                    };
                    ajax.post(api.DELETEBEHAVIOR, params).then(res => {
                        if (res.code === 200) {
                            this.initBehaviorTbale();
                            this.beHaviorRowKeys = [];
                        }
                    });
                } else {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                }
            },
            //      表格checkbox 事件选中的item
            onSelectChange(selectedRowKeys, selectedRows) {
                this.beHaviorRowKeys = selectedRowKeys;
                this.selectBeHaviorRows = selectedRows;
            },

            //      新增beHavior Button
            addBehavior(type, text) {
                this.behaviorVis = true;
                //          至空
                this.form.resetFields();
                this.editFromItems = {};
                this.getConfigJson = {};
                this.behaviorMaoToModel = [];
                this.behaviorModuleModel = [];
                ajax.get(api.GETMODULEDROPDATA).then(res => {
                    this.behaviorMaoToModules = res.data;
                    this.behaviorModules = res.data;
                });
                this.patternTypeApi = "INT";
                if (type == "edit") {
                    ajax.get(api.GETBEHRDROPDATA).then(res => {
                        this.selectBehaviorArr = res.data;
                    });
                    this.editFromItems = text;
                    this.patternTypeApi = text.patternType;
                    this.getConfigJson = text.pattern == null ? {} : text.pattern;
                    this.dropdownVisibleChange();
                    this.gmcuidGeneric = [];
                    if (this.editFromItems.codeKey == "BTN_DELETE") {
                        this.isjlDetele = true;
                    } else {
                        this.isjlDetele = false;
                    }
                } else {
                    //     添加默认值 add
                    ajax.get(api.GETBEHRDROPDATA).then(res => {
                        this.selectBehaviorArr = res.data;
                        this.editFromItems.renderType = this.selectBehaviorArr.renderTypes[1].dataKey;
                        this.editFromItems.type = "BUTTON";
                    });
                }
            },

            genericNameVisibleChange() {
                let params = {
                    functionCode: this.ConfigGmcFunction,
                    moduleCode: this.ConfigGmcModule[0],
                    subModuleCode: this.ConfigGmcModule[1]
                };
                ajax.post(api.POSTFETCH, params).then(res => {
                    this.gmcuidGeneric = res.data;
                });
            },
            dropdownVisibleChange() {
                let params = {
                    fromModuleCode: this.behaviorModuleModel[1],
                    toModuleCode: this.behaviorMaoToModel[1]
                };
                ajax.get(api.DROPFIELMAP, params).then(res => {
                    this.FormFieldMapList = res.data;
                });
            },

            //      提交behavios
            getBehavior() {
                this.form.validateFields((err, val) => {
                    if (!err) {
                        this.getBehaviorDis = true
                        let behrVo = val;
                        behrVo.behrUid = "";
                        if (this.editFromItems.behrUid) {
                            behrVo.behrUid = this.editFromItems.behrUid;
                        }
                        behrVo.gmcUid = this.uid;
                        behrVo.patternType = this.patternTypeApi;
                        if (typeof this.getConfigJson == "string") {
                            behrVo.pattern = JSON.parse(this.getConfigJson);
                        } else {
                            behrVo.pattern = this.getConfigJson;
                        }
                        ajax.post(api.SAVEBEHAVIOR, behrVo).then(res => {
                            if (res.code === 200) {
                                this.initBehaviorTbale();
                                this.form.resetFields();
                                this.getBehaviorDis = false
                                this.behaviorVis = false;
                            }
                        });
                    }
                });
            },
            //      clearJSON
            clearConfigJson() {
                this.getConfigJson = "{}";
            },
            getBehaviorPatterConfig() {
                this.behaviorPatternForm.validateFields((err, val) => {
                    let gmcName = undefined;
                    let getConfigJson = {};
                    let paramArr = [];
                    if (val.gmcUid != undefined) {
                        for (let ii in this.gmcuidGeneric) {
                            if (this.gmcuidGeneric[ii].uid == val.gmcUid) {
                                gmcName = this.gmcuidGeneric[ii].name;
                            }
                        }
                    }
                    getConfigJson.gmcUid = val.gmcUid;
                    getConfigJson.gmcName = gmcName;
                    getConfigJson.custPage = val.custPage;
                    getConfigJson.action = val.action;
                    getConfigJson.params = val.params;
                    getConfigJson.width = val.width;
                    getConfigJson.constraintParams = val.constraintParams;
                    getConfigJson.constraintTableName = val.constraintTableName;
                    this.getConfigJson = JSON.stringify(getConfigJson);
                    this.configPatterVis = false;
                });
            },
            //      点击配置 pattern JSON
            configPatternData() {
                this.configPatterVis = true;
                this.behaviorPatternForm.resetFields();
                if (typeof this.getConfigJson == "string") {
                    this.getConfigJson = JSON.parse(this.getConfigJson);
                }
                this.ConfigGmcModule = [];
                this.ConfigGmcFunction = undefined;
                //          获取patter JSON module function 下拉数据
                ajax.get(api.GETMODULEDROPDATA).then(res => {
                    this.gmcuidModule = res.data;
                });
                ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
                    this.gmcuidfunction = res.data;
                });
                this.genericNameVisibleChange();
                //          type 类型显示不同的条件输入
                this.form.validateFields((err, val) => {
                    if(val.type == "BUTTON") {
                        this.isWidth = false;
                    } else {
                        this.isWidth = true;
                    }
                });
                let schemaParas = {
                    schemaUids: [],
                    uid: this.uid
                };
                ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {
                    this.ParametersList = res.data;
                });
            }
        }
    };
</script>
<style lang="less">
  #beHavior {
    margin-top: 14px;
    .pageProperty-btn {
      margin-bottom: 14px;
      button {
        margin-right: 14px;
      }
    }
  }
  /*框架样式*/
  .ant-modal-body {
    padding-top: 8px !important;
  }
</style>
